// Initialize window.Woolman object
if (typeof window.Woolman == 'undefined') {
  window.Woolman = {};
}

/* ---------------------------------------
 * Focus‑trap helpers
 ----------------------------------------*/

// store all handler fns *and* run‑time data in one object
const trapFocusHandlers = {};

// will hold the element that had focus *before* the trap
let previouslyFocusedElement = null;

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a:not([tabindex^='-']), button:enabled:not([tabindex^='-']), [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function trapFocus(container) {
  // Remove any existing trap first
  removeTrapFocus();

  // Remember what was focused *before* we trap (if it’s outside)
  const current = document.activeElement;
  previouslyFocusedElement =
    current && !container.contains(current) ? current : null;

  /* ---------- calculate first / last focusable ---------- */
  function setFocusableElements() {
    const elements = getFocusableElements(container);
    trapFocusHandlers.first = elements[0];
    trapFocusHandlers.last = elements[elements.length - 1];
  }
  setFocusableElements();   // initialise once

  /* ---------- listeners ---------- */
  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== trapFocusHandlers.last &&
      event.target !== trapFocusHandlers.first
    ) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = () =>
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

  trapFocusHandlers.keydown = (event) => {
    if (event.code.toUpperCase() !== 'TAB') return;

    // TAB forward on the last element  → loop to first
    if (event.target === trapFocusHandlers.last && !event.shiftKey) {
      event.preventDefault();
      trapFocusHandlers.first?.focus();
    }

    // SHIFT+TAB on the first element → loop to last
    if (
      (event.target === container || event.target === trapFocusHandlers.first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      trapFocusHandlers.last?.focus();
    }
  };

  /* ---------- attach listeners ---------- */
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  /* ----------  Watch for DOM changes  ---------- */
  const observer = new MutationObserver(() => {
    setFocusableElements();                  // refresh first / last

    // If focus was lost because the element was removed, restore it:
    if (!container.contains(document.activeElement)) {
      trapFocusHandlers.first?.focus();
    }
  });

  observer.observe(container, { childList: true, subtree: true });

  /* expose a way to stop observing when the trap is removed */
  trapFocusHandlers.disconnect = () => observer.disconnect();

  /* ---------- expose a public “refresh” method ---------- */
  trapFocusHandlers.update = setFocusableElements;

  /* ---------- move initial focus ---------- */
  trapFocusHandlers.first?.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin',  trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown',  trapFocusHandlers.keydown);

  trapFocusHandlers.disconnect?.();

  // prefer the explicit argument, otherwise fall back to previously‑focused element
  if (!elementToFocus && previouslyFocusedElement?.isConnected) {
    elementToFocus = previouslyFocusedElement;
  }

  if (elementToFocus) elementToFocus.focus();

  // clean up
  previouslyFocusedElement = null;
  delete trapFocusHandlers.first;
  delete trapFocusHandlers.last;
  delete trapFocusHandlers.update;
}


/* ---------------------------------------
 * Other helpers
 ----------------------------------------*/

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, wait) {
  let t = false;
  return (...args) => {
    if (!t) {
      fn.apply(this, args)
      t = true;
      setTimeout(() => t = false, wait)
    }
  }
}

/* ---------------------------------------
 * Woolman Common
 ----------------------------------------*/

Woolman.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// -------
// Common: Init
Woolman.init = function () {
  Woolman.ModalsAndDrawers.init();
  Woolman.Header.init();
  Woolman.CustomClassInstanses.init();

   // Attach theme editor listeners
   if (!Shopify || !Shopify.designMode) return;

  let lastSelection = {
    sectionId: undefined,
    blockId: undefined
  };

  // Load is called when something is changed within section settings
  document.addEventListener('shopify:section:load', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    if (sectionId === Woolman.Header.cache.section.id) {
      Woolman.ModalsAndDrawers.init();
      Woolman.Header.init();
    }

    if (document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('shopify:section:load sectionId', evt.detail.sectionId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:block:select', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    const blocks = document.getElementById(sectionId).querySelectorAll('[data-shopify-editor-block]')
    const selectedBlock = [...blocks].find(x => JSON.parse(x.dataset.shopifyEditorBlock).id === evt.detail.blockId);
    if (sectionId === Woolman.Header.cache.section.id) {
      if (selectedBlock) {
        // Make sure menu is open
        Woolman.Header.cache.openButton.click();

        // Select menu item
        const accordion = selectedBlock.closest('[data-accordion-item]').querySelector('input');
        const label = selectedBlock.closest('[data-accordion-item]').querySelector('label');
        if (!accordion.checked) label.click();
      }
    } else if (sectionId.includes('modal') && document.getElementById(sectionId).querySelector('[data-modal]')) {
      if (selectedBlock) {
        Woolman.ModalsAndDrawers.showModalOrDrawer(document.getElementById(sectionId).querySelector('[data-modal]').id);
      }
    }

    lastSelection.sectionId = evt.detail.sectionId;
    lastSelection.blockId = evt.detail.blockId;
    console.log('shopify:block:select', evt.detail.sectionId, evt.detail.blockId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:unload', (evt) => {
    console.log('shopify:section:unload sectionId', evt.detail.sectionId)
  })

  document.addEventListener('shopify:section:select', (evt) => {
    console.log('shopify:section:select', evt.detail.sectionId)
    lastSelection = {
      sectionId: evt.detail.sectionId,
      blockId: evt.detail.blockId
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:deselect', (evt) => {
    console.log('shopify:section:deselect', evt.detail.sectionId)
    lastSelection = {
      sectionId: undefined,
      blockId: undefined
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.closeModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })
};

// -------
// Common: Utility library
Woolman.Utils = {
  debugMode: true,
  prepareQueryParams: () => {
    Shopify.queryParams = Shopify.queryParams || {};

    // Preserve existing query parameters
    if (location.search.length) {
      const params = location.search.substr(1).split('&');
      for (let i = 0; i < params.length; i++) {
        const keyValue = params[i].split('=');
        // Spaces are reverted back after the decode, since in component-facets.js we'll use URLSearchParams() method and we don't want to double decode the spaces
        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]).replaceAll('+', ' ');
        }
      }
    }

    return Shopify.queryParams;
  },
  formatMoney(cents, format) {
    const default_money_format = theme.settings.moneyFormat || '€{{amount}}';
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    if (window?.Shopify?.currency?.rate) {
      cents = cents * parseFloat(window.Shopify.currency.rate || 1.0);
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || default_money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },
};

// -------
// Common: Header component
Woolman.Header = {
  selectors: {
    header: 'MainHeader',
    toolbar: "ToolBar",
    cartBlip: '[data-cart-count]',
    itgCartTotal: '[data-cart-total-price]'
  },
  cache: {
    header: undefined,
    toolbar: undefined,
    cartBlip: undefined,
    itgCartTotal: undefined,
    section: undefined,
    openButton: undefined
  },

  init: function () {
    this.cache.header = document.getElementById(this.selectors.header);
    this.cache.toolbar = document.getElementById(this.selectors.toolbar);
    this.cache.cartBlip = document.querySelectorAll(this.selectors.cartBlip);
    this.cache.itgCartTotal = document.querySelectorAll(this.selectors.itgCartTotal);
    this.cache.section = this.cache.header.closest('.shopify-section');
    this.cache.openButton = this.cache.header.querySelector('[data-open="drawer-menu"]');

    // -- NEW: Set the CSS variable on load
    this.setHeaderHeightVar();

    // -- NEW: Listen to the resize event and recalculate header height
    window.addEventListener('resize', throttle(this.setHeaderHeightVar.bind(this), 40));

    // Update cart blip when product is added to cart.
    document.addEventListener('ajaxProduct:added', this.updateCartBlip.bind(this));
    document.addEventListener('cart:update', this.updateCartBlip.bind(this));

    if (this.cache.header.dataset.stickyBehavior === 'none') return;
    this.initStickyBehavior(this.cache.header.dataset.stickyBehavior);
  },

  // -- NEW: Function that calculates the header’s height and updates documentElement
  setHeaderHeightVar: function() {
    if (!this.cache.header) return;
    const headerHeight = this.cache.header.offsetHeight;
    const toolbarHeight = this.cache.toolbar.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    document.documentElement.style.setProperty('--toolbar-height', `${toolbarHeight}px`);
  },

  initStickyBehavior(behaviorType) {
    const stickyConfig = {
      headerHeight: this.cache.header.clientHeight + 1,
      toolbarHeight: this.cache.toolbar.clientHeight + 1,
      behavior: behaviorType
    }

    document.documentElement.classList.add('sticky-header-initialized', `sticky-header-${behaviorType}`);

    if (behaviorType === 'scroll' || behaviorType === 'fixed') {
      // One-time check if the page is loaded with scroll position
      if (window.scrollY >= 300) {
        document.documentElement.classList.add('sticky-header-show');
      }

      let prevScroll = window.scrollY || document.documentElement.scrollTop;
      let curScroll;
      let direction = 0;
      let prevDirection = 0;

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      const toggleStickyHeader = (direction, curScroll) => {
        if ((direction === 1) || curScroll < stickyConfig.headerHeight) {
          document.documentElement.classList.remove('sticky-header-hide')
        } else if (direction === 2 && curScroll > stickyConfig.headerHeight) {
          document.documentElement.classList.add('sticky-header-hide')
        }

        prevDirection = direction;
      }

      const handleScroll = throttle(() => {
        curScroll = window.scrollY || document.documentElement.scrollTop;
        if (curScroll >= 300) {
          document.documentElement.classList.add('sticky-header-show');
        } else {
          document.documentElement.classList.remove('sticky-header-show');
        }

        // Reset classes when at the top of the page
        if (curScroll === 0) {
          document.documentElement.classList.remove('sticky-header-show', 'sticky-header-hide');
          return;
        }else if (curScroll < 500) {
          document.documentElement.classList.remove('sticky-header-show', 'sticky-header-hide');
          return;
        }

        if (curScroll < prevScroll) {
          direction = 2; // user scrolling down
        } else {
          direction = 1; // user scrolling up
        }

        // Toggle header visibility based on scroll direction and behavior type
        if (direction !== prevDirection && behaviorType === 'scroll') {
          toggleStickyHeader(direction, curScroll);
        } else if (behaviorType === 'scroll' && direction === 2 && curScroll >= 900) {
          // Hide header when scrolling down and past the threshold
          toggleStickyHeader(direction, curScroll);
        }

        prevScroll = curScroll
      }, 40);

      window.addEventListener('scroll', handleScroll);
    }
  },

  async updateCartBlip(e) {
    // const cart = e.detail && e.detail.cart && e.detail.cart.item_count || await (async function () {
    //   const res = await fetch('/cart.json');
    //   const cart = await res.json();
    //   return cart;
    // })();
    // code by RSS --start--
      let cart;
      if (e.detail && e.detail.cart && e.detail.cart.updated_at) {
        cart = e.detail.cart;
      } else {
        const res = await fetch('/cart.json');
        cart = await res.json();
      }
      // console.log("cart" , cart);  
    // code by RSS --End--


    this.cache.cartBlip.forEach((blip) => {
      blip.textContent = cart.item_count || 0;
      if (cart && cart.item_count == 0) {
        blip.setAttribute('hidden', true);
        blip.closest('.cart-button').classList.remove('has-count-visible');
      } else {
        blip.removeAttribute('hidden')
        blip.closest('.cart-button').classList.add('has-count-visible');
      }

      // Update notification cart amount at the same time (if present)
      const total_in_notification = document.querySelector('#cart-notification-link .cart-total');
      if (total_in_notification) {
        total_in_notification.textContent = cart.item_count;
      }
    })
    //--- code by (RSS) start --- //
    this.cache.itgCartTotal.forEach(el => {
      const rate = parseFloat(Shopify.currency.rate) || 1;
      const total = (cart.items_subtotal_price / rate / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: Shopify.currency.active || 'USD'
      });
      
      el.textContent = total;
      el.toggleAttribute('hidden', !cart || cart.item_count === 0);
    });
    //--- code by (RSS) End --- //
  }
};

// -------
// Common: Modals & drawers library
Woolman.ModalsAndDrawers = {
  settings: {
    selectors: {
      modalLink: 'button[data-open*="modal"]:not(.quick-buy-link)',
      drawerLink: 'button[data-open*="drawer"]',
    },
  },
  focusTraps: {},
  init: function () {
    // Init open event listeners
    document.querySelectorAll(this.settings.selectors.modalLink).forEach((modalLink) => {
      modalLink.addEventListener('click', (event) => {
        const targetId = event.currentTarget.dataset.open.split('?')[0];
        const slideIndex = event.currentTarget.dataset.open.split('?slide=')[1];
        const scrollToId = event.currentTarget.dataset.open.split('?scroll=')[1];
        this.showModalOrDrawer(targetId, parseInt(slideIndex), scrollToId);
      });
    });

    document.querySelectorAll(this.settings.selectors.drawerLink).forEach((drawerLink) => {
      drawerLink.addEventListener('click', (event) => {
        const targetId = event.currentTarget.dataset.open.split('?')[0];
        this.showModalOrDrawer(targetId);
      });
    });

    // Init close event listeners
    const closeBtns = document.querySelectorAll('[data-close]');
    if (closeBtns) {
      closeBtns.forEach((closeBtn) => {
        closeBtn.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    const overlays = document.querySelectorAll('[data-overlay]');
    if (overlays) {
      overlays.forEach((overlay) => {
        overlay.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    // Escape to close all
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' || event.keyCode === 27) {
        // Find all open drawers and modals
        const openElements = document.querySelectorAll('.drawer.is-open, .modal.is-open');
        removeTrapFocus();

        openElements.forEach((element) => {
          // Each open modal/drawer should have an ID you can pass to closeModalOrDrawer
          const targetId = element.id;
          Woolman.ModalsAndDrawers.closeModalOrDrawer(targetId);
        });
      }
    });
  },
  /**
   *
   * @param {string} targetId - ID of modal or drawer element, e.g. modal-geo, drawer-menu
   * @param {int} slideIndex - Index of a Gridy Slider slide inside the opened modal - (sliding motion)
   * @param {string} scrollToId - ID of a Gridy Slider slide inside the opened modal - (no motion)
   * Traps focus to modal and disables body scrolling.
   */
  showModalOrDrawer: function (targetId, slideIndex, scrollToId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement && Woolman.Utils.debugMode) {
      console.warn('No modal/drawer element specified');
    }
    if (!targetElement) {
      return;
    }

    if (targetElement.classList.contains('is-open')) return;

    targetElement.classList.add('initialized', 'is-open');
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overlay-open');

    setTimeout(() => {
      trapFocus(targetElement);

      // Focus on drawerSearchInput if it exists
      const drawerSearchInput = targetElement.querySelector('#drawerSearchInput');
      if (drawerSearchInput) {
        drawerSearchInput.focus();
      }
    }, 600);

    if (slideIndex) {
      const gridySlider = targetElement.querySelector('gridy-slider');
      gridySlider.scrollToSlide(slideIndex - 1, 'instant');
    } else if (scrollToId) {
      const gridySlider = targetElement.querySelector('gridy-slider');
      gridySlider.scrollToSlideByID(scrollToId, 'instant');
    }
  },
  closeModalOrDrawer: function(targetId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement) return;

    pauseMediaInElement(targetElement);
    targetElement.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  },
  closeModalOrDrawerOrDrawerFromEvent: function (event) {
    event.preventDefault();
    removeTrapFocus();

    const parentElement = event.currentTarget.closest('[data-parent]');
    if (!parentElement) return;

    pauseMediaInElement(parentElement);
    parentElement.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overlay-open');
  }
};

/**
 * Pauses all <video> elements and sends pause commands to
 * Vimeo/YouTube iframes inside the given container element.
 */
function pauseMediaInElement(container) {
  if (!container) return;

  // Pause HTML5 <video> elements
  const videos = container.querySelectorAll('video');
  videos.forEach((videoEl) => {
    if (!videoEl.paused) {
      videoEl.pause();
    }
  });

  // Look for iframes (Vimeo or YouTube)
  const iframes = container.querySelectorAll('iframe');
  iframes.forEach((iframe) => {
    const src = iframe.src || '';

    // Check for YouTube embedded content
    if (src.includes('youtube.com/embed') || src.includes('youtube-nocookie.com/embed')) {
      // Post message to tell YouTube player to pause
      // Ref: https://developers.google.com/youtube/iframe_api_reference#Events
      iframe.contentWindow?.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'pauseVideo',
          args: [],
        }),
        '*'
      );
    }
    // Check for Vimeo embedded content
    else if (src.includes('vimeo.com')) {
      // Post message to tell Vimeo player to pause
      // Ref: https://developer.vimeo.com/player/js-api#universal-embed-code
      iframe.contentWindow?.postMessage(
        JSON.stringify({
          method: 'pause',
        }),
        '*'
      );
    }
  });
}

// -------
// Common: Resize event listener
window.Woolman.window_size = window.innerWidth;
window.addEventListener(
  'resize',
  debounce(() => {
    if (window.innerWidth === window.Woolman.window_size) {
      return;
    }
    window.Woolman.window_size = window.innerWidth;
    document.dispatchEvent(new CustomEvent('woolman:resize'));
  }),
  50
);

// -------
// Common: Responsive video
class ResponsiveVideo {
  constructor(videoElement) {
    this.videoElement = videoElement;
    this.sources = Array.from(videoElement.querySelectorAll('source'));

    // Extract the sources based on data attributes
    this.defaultSource = this.sources.find(source => source.hasAttribute('data-default-video')).src;
    this.mobileSource = this.sources.find(source => source.hasAttribute('data-mobile-video')).src;

    // Bind the checkVideoSource method to the current instance
    this.checkVideoSource = this.checkVideoSource.bind(this);

    // Add event listener for the woolman:resize event
    document.addEventListener('woolman:resize', this.checkVideoSource);
  }

  checkVideoSource() {
    if (window.Woolman.window_size >= 768) {
      if (this.videoElement.src !== this.defaultSource) {
        this.videoElement.src = this.defaultSource;
      }
    } else {
      if (this.videoElement.src !== this.mobileSource) {
        this.videoElement.src = this.mobileSource;
      }
    }
  }
}

// -------
// Common: Autoplay videos play/pause observer
class AutoplayVideosObserver {
  constructor() {
    this.autoplayVideos = document.querySelectorAll('video[autoplay]');
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      threshold: 0.01
    });

    this.autoplayVideos.forEach((video) => {
      this.observer.observe(video);
    });
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.play();
      } else {
        entry.target.pause();
      }
    });
  }
}

// -------
// Common: Accordion (animations)
class Accordion {
  constructor(detailsElement) {
    if (detailsElement.hasAttribute('data-no-accordion-logic')) {
      return;
    }
    this.detailsElement = detailsElement;
    this.summary = detailsElement.querySelector('summary');
    this.content = detailsElement.querySelector('.content');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
    this.toggleByViewport();
    document.addEventListener('woolman:resize', this.toggleByViewport.bind(this));
  }

  onClick(e) {
    e.preventDefault();
    this.detailsElement.style.overflow = 'hidden';
    if (this.isClosing || !this.detailsElement.open) {
      this.open();
    } else if (this.isExpanding || this.detailsElement.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.detailsElement.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.detailsElement.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-in-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.detailsElement.style.height = `${this.detailsElement.offsetHeight}px`;
    this.detailsElement.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.detailsElement.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.detailsElement.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.detailsElement.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.detailsElement.style.height = this.detailsElement.style.overflow = '';
  }

  toggleByViewport() {
    let mobileClose = this.detailsElement.dataset.mobileClose != undefined ? JSON.parse(this.detailsElement.dataset.mobileClose) : false;
    let desktopOpen = this.detailsElement.dataset.desktopOpen != undefined ? JSON.parse(this.detailsElement.dataset.desktopOpen) : false;

    if (window.Woolman.window_size >= 768 && desktopOpen) {
      this.detailsElement.open = true;
    } else if (mobileClose) {
      this.detailsElement.open = false;
    }
  }
};

// -------
// Common: Details Accordions
Woolman.CustomClassInstanses = {
  init: function () {
    // Accordions
    document.querySelectorAll('details').forEach((detailsElement) => {
      new Accordion(detailsElement);
    });
    // Responsive videos
    document.querySelectorAll('video[data-responsive-video]').forEach((videoElement) => {
      new ResponsiveVideo(videoElement);
    });
    // Autoplay videos play/pause observer
    new AutoplayVideosObserver();
  }
};

// Ensure Woolman.init is called after the document content is loaded
document.addEventListener('DOMContentLoaded', function() {
  Woolman.init();
});

/* ---------------------------------------
 * Woolman Web Components
 ----------------------------------------*/
class ModalDrawerButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    event.preventDefault();
    const targetId = this.button.dataset.open.split('?')[0];
    const slideIndex = this.button.dataset.open.split('?slide=')[1];
    const scrollToId = this.button.dataset.open.split('?scroll=')[1];
    Woolman.ModalsAndDrawers.showModalOrDrawer(targetId, parseInt(slideIndex), scrollToId);
  }
}
customElements.define('modal-drawer-button', ModalDrawerButton);

class HeaderDropdown extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.header = this.closest('header'); // Define the header element once
    this.timer = null;

    // Bind 'this' so that we can add/remove the listener properly if needed.
    this.handleEscKey = this.handleEscKey.bind(this);

    this.summary.addEventListener('mouseenter', this.openDropdown.bind(this));
    this.details.addEventListener('mouseenter', this.clearCloseTimer.bind(this));
    this.details.addEventListener('mouseleave', this.startCloseTimer.bind(this));
    this.summary.addEventListener('keydown', this.handleKeydown.bind(this));

    // Add an ESC key listener on the document (in a real app, maybe do this once globally)
    document.addEventListener('keydown', this.handleEscKey);
  }

  openDropdown() {
    this.closeOtherDropdowns();
    this.details.open = true;
    if (this.header) {
      this.header.classList.add('sub-menu-open');
    }
  }

  handleEscKey(event) {
    if (event.key === 'Escape') {
      this.closeAllDropdowns();
    }
  }

  closeAllDropdowns() {
    const openDropdowns = document.querySelectorAll('header-dropdown details[open]');
    openDropdowns.forEach((dropdown) => {
      dropdown.open = false;
    });

    const headers = document.querySelectorAll('header');
    headers.forEach((hdr) => hdr.classList.remove('sub-menu-open'));
  }

  closeOtherDropdowns() {
    if (this.header) {
      const otherDropdowns = this.header.querySelectorAll('header-dropdown details[open]');
      otherDropdowns.forEach(dropdown => {
        if (dropdown !== this.details) {
          dropdown.open = false;
          const parentDropdown = dropdown.closest('header-dropdown');
          if (parentDropdown && typeof parentDropdown.clearCloseTimer === 'function') {
            parentDropdown.clearCloseTimer();
          }
        }
      });
    }
  }

  startCloseTimer() {
    this.timer = setTimeout(() => {
      this.details.open = false;
      if (this.header) {
        this.header.classList.remove('sub-menu-open');
      }
    }, 400);
  }

  clearCloseTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      // Prevent default behavior to avoid double toggling
      event.preventDefault();
      if (!this.details.open) {
        this.openDropdown();
      } else {
        this.details.open = false;
        if (this.header) {
          this.header.classList.remove('sub-menu-open');
        }
      }
    }
  }
}
customElements.define('header-dropdown', HeaderDropdown);

// Custom element that enhances Localization form functionality.
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]')
    };

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;

    // Filter params fix, replace "%2C" with ","
    let return_to_value = form.querySelector('[name="return_to"]').value;
    let indexOfFilters = return_to_value.indexOf("?filter");
    if (indexOfFilters !== -1) {
        let substringAfterFilters = return_to_value.substring(indexOfFilters);
        let replacedSubstring = substringAfterFilters.replace(/%2C/g, ",");
        form.querySelector('[name="return_to"]').value = return_to_value.substring(0, indexOfFilters) + replacedSubstring;
    }

    if (form) form.submit();
  }
}
customElements.define('localization-form', LocalizationForm);


// Gridy Slider - a custom Woolman built slider.

// class GridySlider extends HTMLElement {
//   constructor() {
//     super();

//     this.track = this.querySelector('.gridy-track');
//     this.slides = Array.from(this.track?.children || []);
//     if (!this.track || !this.slides.length) return;

//     /* ================= CONFIG ================= */
//     this.config = {
//       slide_count: this.slides.length,
//       current_slide: 0,

//       ipr_desktop: parseInt(this.dataset.iprDesktop, 10) || 1,
//       ipr_tablet: parseInt(this.dataset.iprTablet, 10) || 1,
//       ipr_mobile: parseInt(this.dataset.iprMobile, 10) || 1,

//       breakpoint_tablet: 768,
//       breakpoint_desktop: 1024,

//       autoplay: this.dataset.autoplay ? JSON.parse(this.dataset.autoplay) : false,
//       autoplay_delay: parseInt(this.dataset.autoplayDelay, 10) || 5000,

//       indicator: this.dataset.indicator ? JSON.parse(this.dataset.indicator) : false,
//     };

//     this.lastPageIndex = 0;

//     /* ================= DRAG STATE ================= */
//     this.isDragging = false;
//     this.startX = 0;
//     this.dragDistance = 0;
//     this.dragThreshold = 50; // minimum px to trigger slide change

//     /* ================= BIND ================= */
//     this.onResize = this.onResize.bind(this);

//     /* ================= INIT ================= */
//     this.setupIndicators();
//     this.updateActiveSlide(0, false);
//     this.addEventListeners();

//     if (this.config.autoplay) this.startAutoplay();
//   }

//   /* ================= HELPERS ================= */
//   getItemsPerView() {
//     const w = window.innerWidth;
//     return w >= this.config.breakpoint_desktop
//       ? this.config.ipr_desktop
//       : w >= this.config.breakpoint_tablet
//       ? this.config.ipr_tablet
//       : this.config.ipr_mobile;
//   }

//   getSlideWidth() {
//     return this.track.clientWidth / this.getItemsPerView();
//   }

//   getMaxSlideIndex() {
//     return Math.max(0, this.config.slide_count - this.getItemsPerView());
//   }

//   clampSlideIndex(index) {
//     return Math.max(0, Math.min(index, this.getMaxSlideIndex()));
//   }

//   getPageIndexFromSlide(slideIndex) {
//     return Math.floor(slideIndex / this.getItemsPerView());
//   }

//   /* ================= SCROLL ================= */
//     scrollToSlide(index, behavior = 'smooth') {
//       const target = this.clampSlideIndex(index);
//       const left = this.getSlideWidth() * target;
//       this.track.scrollTo({ left, behavior });
//       this.updateActiveSlide(target, false);
      
//     //  Restart autoplay timer after manual slide
//       if (this.config.autoplay) {
//       this.stopAutoplay();
//       this.startAutoplay();
//     }
//     }

//   /* ================= ACTIVE STATE ================= */
//   updateActiveSlide(index, syncScroll = true) {
//     const activeIndex = this.clampSlideIndex(index);
//     this.config.current_slide = activeIndex;

//     this.slides.forEach(s => s.classList.remove('active'));
//     this.slides[activeIndex]?.classList.add('active');

//     const pageIndex = this.getPageIndexFromSlide(activeIndex);
//     this.updateDots(pageIndex);
//     this.updateSlideVideos();

//     if (syncScroll) {
//       const left = this.getSlideWidth() * activeIndex;
//       if (Math.abs(this.track.scrollLeft - left) > 1) {
//         this.track.scrollTo({ left, behavior: 'smooth' });
//       }
//     }
//   }

//   /* ================= DOTS ================= */
//   setupIndicators() {
//     if (!this.config.indicator) return;

//     const container = this.querySelector('.indicator--dots');
//     if (!container) return;

//     container.innerHTML = '';
//     // const pages = Math.ceil(this.config.slide_count / this.getItemsPerView());
//     // if(pages > 1) {
//     //   for (let i = 0; i < pages; i++) {
//     //     const dot = document.createElement('div');
//     //     dot.className = 'dot';
//     //     dot.addEventListener('click', () =>
//     //       // this.scrollToSlide(i * this.getItemsPerView())
//     //       this.scrollToSlide(i)
//     //     );
//     //     container.appendChild(dot);
//     //   }
//     // }
//     const dotsCount = Math.max(1, this.config.slide_count - this.getItemsPerView() + 1);
//     for (let i = 0; i < dotsCount; i++) {
//       const dot = document.createElement('div');
//       dot.className = 'dot';
//       dot.addEventListener('click', () => {
//         this.scrollToSlide(i); 
//       });
//       container.appendChild(dot);
//     }


//     this.indicator_elements = Array.from(container.children);
//     this.updateDots(0);
//   }

//   updateDots(pageIndex) {
//     if (!this.indicator_elements) return;
//     this.indicator_elements.forEach(d => d.classList.remove('active'));
//     this.indicator_elements[pageIndex]?.classList.add('active');
//   }

//   /* ================= ARROWS ================= */
//   onArrowClick(e) {
//     const dir = e.currentTarget.dataset.direction;
//     const step = this.getItemsPerView();

//     const next =
//       dir === 'next'
//         ? this.config.current_slide + step
//         : this.config.current_slide - step;

//     this.scrollToSlide(next);
//   }

//   /* ================= VIDEO ================= */
//   updateSlideVideos() {
//     const start = this.config.current_slide;
//     const end = start + this.getItemsPerView() - 1;

//     this.slides.forEach((slide, i) => {
//       slide.querySelectorAll('video').forEach(video => {
//         if (i >= start && i <= end) {
//           if (video.autoplay && video.paused) video.play().catch(() => {});
//         } else {
//           if (!video.paused) video.pause();
//         }
//       });
//     });
//   }

//   /* ================= AUTOPLAY ================= */
//   startAutoplay() {
//     this.stopAutoplay();
//     this.config.timer = setInterval(() => {
//       // this.scrollToSlide(this.config.current_slide + this.getItemsPerView());
//       this.scrollToSlide(this.config.current_slide + 1);
//     }, this.config.autoplay_delay);

//     this.addEventListener('mouseenter', () => this.stopAutoplay());
//     this.addEventListener('mouseleave', () => this.startAutoplay());
//   }

//   stopAutoplay() {
//     clearInterval(this.config.timer);
//     this.config.timer = null;
//   }

//   /* ================= DRAG ================= */
//   addEventListeners() {
//     // Mouse
//     this.track.addEventListener('mousedown', e => this.startDrag(e.clientX));
//     window.addEventListener('mousemove', e => this.dragMove(e.clientX));
//     window.addEventListener('mouseup', () => this.endDrag());

//     // Touch
//     this.track.addEventListener('touchstart', e => this.startDrag(e.touches[0].clientX), { passive: false });
//     this.track.addEventListener('touchmove', e => this.dragMove(e.touches[0].clientX), { passive: false });
//     this.track.addEventListener('touchend', () => this.endDrag());
//     this.track.addEventListener('touchcancel', () => this.endDrag());

//     // Arrows
//     this.querySelectorAll('[data-gridy-arrow]').forEach(btn =>
//       btn.addEventListener('click', this.onArrowClick)
//     );

//     // Resize
//     window.addEventListener('resize', this.onResize);
//   }

//   startDrag(clientX) {
//     this.isDragging = true;
//     this.startX = clientX;
//     this.dragDistance = 0;
//   }

//   dragMove(clientX) {
//     if (!this.isDragging) return;
//     this.dragDistance = clientX - this.startX;
//   }

//   // endDrag() {
//   //   if (!this.isDragging) return;
//   //   this.isDragging = false;

//   //   if (this.dragDistance > this.dragThreshold) {
//   //     // Drag right → prev slide
//   //     this.scrollToSlide(this.config.current_slide - 1);
//   //   } else if (this.dragDistance < -this.dragThreshold) {
//   //     // Drag left → next slide
//   //     this.scrollToSlide(this.config.current_slide + 1);
//   //   } else {
//   //     // Not enough drag → snap back
//   //     this.scrollToSlide(this.config.current_slide);
//   //   }

//   //   this.dragDistance = 0;
//   // }
//   endDrag() {
//     if (!this.isDragging) return;
//     this.isDragging = false;

//     let nextSlide = this.config.current_slide;

//     if (this.dragDistance > this.dragThreshold) {
//       nextSlide = this.config.current_slide - 1;
//     } else if (this.dragDistance < -this.dragThreshold) {
//       nextSlide = this.config.current_slide + 1;
//     }

//     // Add a tiny delay for smooth scroll on mobile
//     setTimeout(() => {
//       this.scrollToSlide(nextSlide, 'smooth');
//     }, 10);

//     this.dragDistance = 0;
//   }

//   /* ================= RESIZE ================= */
//   onResize() {
//     this.setupIndicators();
//     this.scrollToSlide(this.config.current_slide, 'auto');
//   }

//   disconnectedCallback() {
//     window.removeEventListener('resize', this.onResize);
//     this.stopAutoplay();
//   }
// }

class GridySlider extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector('.gridy-track');
    this.slides = Array.from(this.track?.children || []);
    if (!this.track || !this.slides.length) return;

    /* ================= CONFIG ================= */
    this.config = {
      slide_count: this.slides.length,
      current_slide: 0,

      ipr_desktop: parseInt(this.dataset.iprDesktop, 10) || 1,
      ipr_tablet: parseInt(this.dataset.iprTablet, 10) || 1,
      ipr_mobile: parseInt(this.dataset.iprMobile, 10) || 1,

      breakpoint_tablet: 768,
      breakpoint_desktop: 1024,

      autoplay: this.dataset.autoplay ? JSON.parse(this.dataset.autoplay) : false,
      autoplay_delay: parseInt(this.dataset.autoplayDelay, 10) || 5000,

      indicator: this.dataset.indicator ? JSON.parse(this.dataset.indicator) : false,
    };

    /* ================= DRAG STATE ================= */
    this.isDragging = false;
    this.startX = 0;
    this.dragDistance = 0;
    this.dragThreshold = 50; // minimum px to trigger slide change

    /* ================= BIND ================= */
    this.onResize = this.onResize.bind(this);

    /* ================= INIT ================= */
    this.setupIndicators();
    this.updateActiveSlide(0, false);
    this.addEventListeners();

    if (this.config.autoplay) this.startAutoplay();
  }

  /* ================= HELPERS ================= */
  getItemsPerView() {
    const w = window.innerWidth;
    return w >= this.config.breakpoint_desktop
      ? this.config.ipr_desktop
      : w >= this.config.breakpoint_tablet
      ? this.config.ipr_tablet
      : this.config.ipr_mobile;
  }

  getSlideWidth() {
    return this.track.clientWidth / this.getItemsPerView();
  }

  getMaxSlideIndex() {
    return Math.max(0, this.config.slide_count - 1); // slide one by one
  }

  clampSlideIndex(index) {
    return Math.max(0, Math.min(index, this.getMaxSlideIndex()));
  }

  getPageIndexFromSlide(slideIndex) {
    const itemsPerView = this.getItemsPerView();
    const maxStart = this.config.slide_count - itemsPerView;
    if (slideIndex >= maxStart) return maxStart; // last page
    return slideIndex;
  }
  scrollToSlideByID(id, behavior = 'smooth') {
    const slide = document.getElementById(id);
    if (!slide) return;
    const index = Array.from(slide.parentNode.children).indexOf(slide);
    this.scrollToSlide(index, behavior);
  }

  /* ================= SCROLL ================= */
  scrollToSlide(index, behavior = 'smooth') {
    const target = this.clampSlideIndex(index);
    const left = this.getSlideWidth() * target;

    // Smooth scroll
    this.track.scrollTo({ left, behavior });

    this.updateActiveSlide(target, false);

    // Restart autoplay after manual interaction
    if (this.config.autoplay) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  /* ================= ACTIVE STATE ================= */
  updateActiveSlide(index, syncScroll = true) {
    const activeIndex = this.clampSlideIndex(index);
    this.config.current_slide = activeIndex;

    this.slides.forEach(s => s.classList.remove('active'));
    this.slides[activeIndex]?.classList.add('active');

    const pageIndex = this.getPageIndexFromSlide(activeIndex);
    this.updateDots(pageIndex);

    this.updateSlideVideos();

    if (syncScroll) {
      const left = this.getSlideWidth() * activeIndex;
      if (Math.abs(this.track.scrollLeft - left) > 1) {
        this.track.scrollTo({ left, behavior: 'smooth' });
      }
    }
  }

  /* ================= DOTS ================= */
  setupIndicators() {
    if (!this.config.indicator) return;

    const container = this.querySelector('.indicator--dots');
    if (!container) return;

    container.innerHTML = '';

    const itemsPerView = this.getItemsPerView();
    const dotsCount = Math.max(1, this.config.slide_count - itemsPerView + 1);
    if(dotsCount > 1){
      for (let i = 0; i < dotsCount; i++) {
        const dot = document.createElement('div');
        dot.className = 'dot';
        dot.addEventListener('click', () => {
          this.scrollToSlide(i); 
        });
        container.appendChild(dot);
      }
    }

    this.indicator_elements = Array.from(container.children);
    this.updateDots(this.getPageIndexFromSlide(this.config.current_slide));
  }

  updateDots(pageIndex) {
    if (!this.indicator_elements) return;
    this.indicator_elements.forEach(d => d.classList.remove('active'));
    this.indicator_elements[pageIndex]?.classList.add('active');
  }

  /* ================= ARROWS ================= */
  onArrowClick = (e) => {
    const dir = e.currentTarget.dataset.direction;
    const next = dir === 'next'
      ? this.config.current_slide + 1
      : this.config.current_slide - 1;

    this.scrollToSlide(next);
  }

  /* ================= VIDEO ================= */
  updateSlideVideos() {
    const start = this.config.current_slide;
    const end = start + this.getItemsPerView() - 1;

    this.slides.forEach((slide, i) => {
      slide.querySelectorAll('video').forEach(video => {
        if (i >= start && i <= end) {
          if (video.autoplay && video.paused) video.play().catch(() => {});
        } else {
          if (!video.paused) video.pause();
        }
      });
    });
  }

  /* ================= AUTOPLAY ================= */
  startAutoplay() {
    this.stopAutoplay();
    this.config.timer = setInterval(() => {
      // this.scrollToSlide(this.config.current_slide + 1); // move 1 slide
      const itemsPerView = this.getItemsPerView();
      if(this.config.current_slide > itemsPerView ){
        this.scrollToSlide(0);
      }else {
        this.scrollToSlide(this.config.current_slide + 1); // move 1 slide
      }
    }, this.config.autoplay_delay);

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
  }

  stopAutoplay() {
    clearInterval(this.config.timer);
    this.config.timer = null;
  }

  /* ================= DRAG ================= */
  // addEventListeners() {
  //   // Mouse
  //   this.track.addEventListener('mousedown', e => this.startDrag(e.clientX));
  //   window.addEventListener('mousemove', e => this.dragMove(e.clientX));
  //   window.addEventListener('mouseup', () => this.endDrag());

  //   // Touch
  //   this.track.addEventListener('touchstart', e => this.startDrag(e.touches[0].clientX), { passive: false });
  //   this.track.addEventListener('touchmove', e => {
  //     if (this.isDragging) e.preventDefault();
  //     this.dragMove(e.touches[0].clientX);
  //   }, { passive: false });
  //   this.track.addEventListener('touchend', () => this.endDrag());
  //   this.track.addEventListener('touchcancel', () => this.endDrag());

  //   // Arrows
  //   this.querySelectorAll('[data-gridy-arrow]').forEach(btn =>
  //     btn.addEventListener('click', this.onArrowClick)
  //   );

  //   // Resize
  //   window.addEventListener('resize', this.onResize);
  // }
  addEventListeners() {
    // Mouse
    this.track.addEventListener('mousedown', e => this.startDrag(e.clientX, e.clientY));
    window.addEventListener('mousemove', e => this.dragMove(e.clientX, e.clientY));
    window.addEventListener('mouseup', () => this.endDrag());

    // Touch
    this.track.addEventListener('touchstart', e => {
      const touch = e.touches[0];
      this.startDrag(touch.clientX, touch.clientY);
    }, { passive: true });

    this.track.addEventListener('touchmove', e => {
      if (!this.isDragging) return;

      const touch = e.touches[0];
      const deltaX = touch.clientX - this.startX;
      const deltaY = touch.clientY - this.startY;

      // Only prevent vertical scroll if horizontal drag dominates
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        e.preventDefault(); // stop vertical scroll
        this.dragMove(touch.clientX);
      }
    }, { passive: false });

    this.track.addEventListener('touchend', () => this.endDrag());
    this.track.addEventListener('touchcancel', () => this.endDrag());

    // Keep the active slide + dot in sync with wherever the track actually scrolls to
    // (drag, momentum, native scroll), not just the +/-1 estimate in endDrag.
    this.onScroll = this.onScroll.bind(this);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });

    // Arrows
    this.querySelectorAll('[data-gridy-arrow]').forEach(btn =>
      btn.addEventListener('click', this.onArrowClick)
    );

    // Resize
    window.addEventListener('resize', this.onResize);
  }

  // Debounced to scroll-end so it doesn't fire mid-animation; updates active slide + dots
  // from the real scroll position without re-scrolling.
  onScroll() {
    if (this._scrollSyncTimer) clearTimeout(this._scrollSyncTimer);
    this._scrollSyncTimer = setTimeout(() => {
      this._scrollSyncTimer = null;
      if (this.isDragging) return;

      const width = this.getSlideWidth();
      if (!width) return;

      const index = this.clampSlideIndex(Math.round(this.track.scrollLeft / width));
      if (index !== this.config.current_slide) {
        this.updateActiveSlide(index, false);
      }
    }, 100);
  }

  // startDrag(clientX) {
  //   this.isDragging = true;
  //   this.startX = clientX;
  //   this.dragDistance = 0;
  // }
  // startDrag(clientX, clientY = 0) {
  //   this.isDragging = true;
  //   this.startX = clientX;
  //   this.startY = clientY; 
  //   this.dragDistance = 0;
  // }
  // dragMove(clientX) {
  //   if (!this.isDragging) return;
  //   this.dragDistance = clientX - this.startX;
  // }

  // endDrag() {
  //   if (!this.isDragging) return;
  //   this.isDragging = false;

  //   let nextSlide = this.config.current_slide;

  //   if (this.dragDistance > this.dragThreshold) {
  //     nextSlide = this.config.current_slide - 1;
  //   } else if (this.dragDistance < -this.dragThreshold) {
  //     nextSlide = this.config.current_slide + 1;
  //   }

  //   // Small timeout for mobile smooth scrolling
  //   setTimeout(() => {
  //     this.scrollToSlide(nextSlide, 'smooth');
  //   }, 50);

  //   this.dragDistance = 0;
  // }
  startDrag(clientX, clientY = 0) {
    this.isDragging = true;
    this.startX = clientX;
    this.startY = clientY;
    this.startScrollLeft = this.track.scrollLeft;
    this.dragDistance = 0;
  }
  dragMove(clientX) {
    if (!this.isDragging) return;

    this.dragDistance = clientX - this.startX;

    // THIS is the key for iOS
    this.track.scrollLeft = this.startScrollLeft - this.dragDistance;
  }
  endDrag() {
    if (!this.isDragging) return;
    this.isDragging = false;

    let nextSlide = this.config.current_slide;

    if (this.dragDistance > this.dragThreshold) {
      nextSlide--;
    } else if (this.dragDistance < -this.dragThreshold) {
      nextSlide++;
    }

    nextSlide = this.clampSlideIndex(nextSlide);

    // Now Safari allows smooth scroll again
    requestAnimationFrame(() => {
      this.scrollToSlide(nextSlide, 'smooth');
    });

    this.dragDistance = 0;
  }


  /* ================= RESIZE ================= */
  onResize() {
    this.setupIndicators();
    this.scrollToSlide(this.config.current_slide, 'auto');
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    if (this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
    if (this._scrollSyncTimer) clearTimeout(this._scrollSyncTimer);
    this.stopAutoplay();
  }
}

customElements.define('gridy-slider', GridySlider);



// class GridySlider extends HTMLElement {
//   constructor() {
//     super();

//     this.track = this.querySelector('.gridy-track');
//     this.slides = this.querySelectorAll('.gridy-track > *');

//     if (!this.track || !this.slides.length) {
//       console.error('GridySlider: Track or slides not found.');
//       return;
//     }

//     const child_count = this.track.childElementCount;

//     // ===== DATA ATTRIBUTES =====
//     const data_ipr_desktop = parseInt(this.dataset.iprDesktop, 10) || 1;
//     const data_ipr_tablet = parseInt(this.dataset.iprTablet, 10) || data_ipr_desktop;
//     const data_ipr_mobile = parseInt(this.dataset.iprMobile, 10) || 1;
//     const data_init_scroll_to = this.dataset.initScrollTo;
//     const data_autoplay = this.dataset.autoplay !== undefined ? JSON.parse(this.dataset.autoplay) : false;
//     const data_autoplay_delay = parseInt(this.dataset.autoplayDelay, 10) || 5000;
//     const data_is_thumbnails_slider = this.dataset.thumbnailsFor !== undefined;
//     const data_indicator = this.dataset.indicator !== undefined ? JSON.parse(this.dataset.indicator) : false;
//     const data_indicator_type = this.dataset.indicatorType;
//     const data_progress_bar = this.dataset.progressBar !== undefined ? JSON.parse(this.dataset.progressBar) : false;
//     const data_sliding_behavior = this.dataset.slidingBehavior;
//     const data_thumbnail_slider = document.getElementById(`thumbnail-${this.id}`);
//     const data_track_overflow_visible = this.dataset.overflowVisible !== undefined;

//     // ===== CONFIG =====
//     this.config = {
//       slide_count: child_count,
//       current_slide: 0,
//       active_slide_offset: 0,

//       ipr_desktop: data_ipr_desktop,
//       ipr_tablet: data_ipr_tablet,
//       ipr_mobile: data_ipr_mobile,
//       breakpoint_tablet: 768,
//       breakpoint_desktop: 1024,

//       arrows: true,
//       autoplay: data_autoplay,
//       autoplay_delay: data_autoplay_delay,
//       timer: null,

//       is_thumbnails_slider: data_is_thumbnails_slider,
//       thumbnails_for: undefined,
//       thumbnail_slider: data_thumbnail_slider,

//       indicator: data_indicator,
//       indicator_type: data_indicator_type,

//       progress_bar: data_progress_bar,

//       track_overflow_visible: data_track_overflow_visible,
//       sliding_behavior: data_sliding_behavior || 'all',

//       track_width: this.track.clientWidth,
//       currentIPR: 1
//     };

//     // ===== BIND =====
//     this.onIndicatorClick = this.onIndicatorClick.bind(this);
//     this.clearAutoplayTimer = this.clearAutoplayTimer.bind(this);
//     this.autoplayGridy = this.autoplayGridy.bind(this);
//     this.updateCurrentIPR = this.updateCurrentIPR.bind(this);
//     this.updateDotsByDevice = this.updateDotsByDevice.bind(this);

//     // ===== INIT =====
//     this.updateCurrentIPR();
//     window.addEventListener('resize', () => {
//       this.updateCurrentIPR();
//       this.updateDotsByDevice();
//     });

//     // Init scroll by ID
//     if (data_init_scroll_to !== undefined) {
//       this.scrollToSlideByID(data_init_scroll_to, 'auto');
//     }

//     // ===== AUTOPLAY =====
//     if (this.config.autoplay) {
//       this.autoplayGridy();
//       this.addEventListener('mouseenter', this.clearAutoplayTimer);
//       this.addEventListener('mouseleave', this.autoplayGridy);
//     }

//     // ===== THUMBNAILS =====
//     if (this.config.is_thumbnails_slider) {
//       this.config.active_slide_offset = 2;
//       this.config.thumbnails_for = document.getElementById(this.dataset.thumbnailsFor);

//       this.boundOnThumbnailClick = this.onThumbnailClick.bind(this);
//       this.thumbnail = this.querySelectorAll('[data-thumbnail-btn]');
//       this.thumbnail.forEach(btn => btn.addEventListener('click', this.boundOnThumbnailClick));
//     }

//     // ===== INDICATORS =====
//     if (this.config.indicator) {
//       this.indicator_elements = Array.from(this.querySelectorAll(
//         `[data-indicator-${this.config.indicator_type}]`
//       ));
//       this.indicator_current = this.querySelector('[data-indicator-current]');

//       this.generateDots();           // create dots dynamically
//       this.updateDotsByDevice();     // show correct dots for device
//     }

//     // ===== SCROLL LISTENER =====
//     let scrollTimeout;
//     this.track.addEventListener('scroll', () => {
//       clearTimeout(scrollTimeout);
//       scrollTimeout = setTimeout(() => this.afterScrollStops(), 200);
//     });

//     this.updateSlideVideos();
//     this.classList.add('js-initialized');
//   }

//   connectedCallback() {
//     this.boundOnArrowClick = this.onArrowClick.bind(this);
//     this.buttons = this.querySelectorAll('[data-gridy-arrow]');
//     this.buttons.forEach(btn => btn.addEventListener('click', this.boundOnArrowClick));
//   }

//   disconnectedCallback() {
//     window.removeEventListener('resize', this.updateCurrentIPR);

//     if (this.buttons) {
//       this.buttons.forEach(btn => btn.removeEventListener('click', this.boundOnArrowClick));
//     }

//     if (this.thumbnail) {
//       this.thumbnail.forEach(btn => btn.removeEventListener('click', this.boundOnThumbnailClick));
//     }

//     if (this.indicator_elements) {
//       this.indicator_elements.forEach(dot => dot.removeEventListener('click', this.onIndicatorClick));
//     }
//   }

//   // ===== INDICATOR CLICK =====
//   onIndicatorClick(event) {
//     event.preventDefault();
//     const index = this.indicator_elements.indexOf(event.currentTarget);
//     if (index === -1) return;

//     this.config.current_slide = index;
//     this.scrollToSlide(index);
//   }

//   // ===== ARROWS =====
//   onArrowClick(event) {
//     this.scrollByIPR(event.currentTarget.dataset.direction);
//   }

//   scrollByIPR(direction) {
//     const ipr = this.config.currentIPR;
//     const last = this.config.slide_count - ipr;

//     let next = this.config.current_slide;
//     if (direction === 'next') next = next >= last ? 0 : next + ipr;
//     else next = next <= 0 ? last : next - ipr;

//     this.config.current_slide = next;
//     this.scrollToSlide(next);
//   }

//   // ===== SCROLL TO SLIDE =====
//   scrollToSlide(index, behavior = 'smooth') {
//     if (!this.slides[index]) return;
//     const slideWidth = this.track.clientWidth;
//     const scrollLeft = slideWidth * index;
//     this.track.scrollTo({ left: scrollLeft, behavior });
//     this.updateActiveSlide(index);
//   }

//   scrollToSlideByID(id, behavior = 'smooth') {
//     const slide = document.getElementById(id);
//     if (!slide) return;
//     const index = Array.from(slide.parentNode.children).indexOf(slide);
//     this.scrollToSlide(index, behavior);
//   }

//   afterScrollStops() {
//     const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
//     this.config.current_slide = index;
//     this.updateActiveSlide(index);
//   }

//   updateActiveSlide(index) {
//     this.slides.forEach(s => s.classList.remove('active'));
//     this.slides[index]?.classList.add('active');

//     if (this.config.indicator) {
//       this.indicator_elements.forEach(d => d.classList.remove('active'));
//       this.indicator_elements[index]?.classList.add('active');
//       if (this.indicator_current) this.indicator_current.textContent = index + 1;
//     }

//     this.updateSlideVideos();
//   }

//   updateCurrentIPR() {
//     const w = window.innerWidth;
//     this.config.currentIPR =
//       w >= 1024 ? this.config.ipr_desktop :
//       w >= 768 ? this.config.ipr_tablet :
//       this.config.ipr_mobile;
//   }

//   updateSlideVideos() {
//     const start = this.config.current_slide;
//     const end = start + this.config.currentIPR - 1;

//     this.slides.forEach((slide, i) => {
//       slide.querySelectorAll('video').forEach(video => {
//         if (i >= start && i <= end) {
//           if (video.hasAttribute('autoplay') && video.paused) video.play().catch(() => {});
//         } else {
//           if (!video.paused) video.pause();
//         }
//       });
//     });
//   }

//   // ===== AUTOPLAY =====
//   clearAutoplayTimer() {
//     clearInterval(this.config.timer);
//     this.config.timer = null;
//   }

//   autoplayGridy() {
//     this.config.timer = setInterval(() => this.scrollByIPR('next'), this.config.autoplay_delay);
//   }

//   onThumbnailClick(event) {
//     event.preventDefault();
//     const index = Array.from(event.currentTarget.parentNode.children).indexOf(event.currentTarget);
//     this.scrollToSlide(index);
//   }

//   // ===== DOTS LOGIC =====
//   generateDots() {
//     const container = this.querySelector('.indicator--dots');
//     if (!container) return;

//     container.innerHTML = ''; // clear existing dots
//     for (let i = 0; i < this.config.slide_count; i++) {
//       const dot = document.createElement('div');
//       dot.className = 'dot' + (i === 0 ? ' active' : '');
//       dot.dataset.indicatorDot = '';
//       dot.addEventListener('click', this.onIndicatorClick);
//       container.appendChild(dot);
//     }
//     this.indicator_elements = Array.from(container.children);
//   }

//   updateDotsByDevice() {
//     const container = this.querySelector('.indicator--dots');
//     if (!container) return;

//     let maxSlides = this.config.slide_count;
//     const w = window.innerWidth;
//     if (w < 768) maxSlides = Math.ceil(this.config.slide_count / this.config.ipr_mobile);
//     else if (w < 1024) maxSlides = Math.ceil(this.config.slide_count / this.config.ipr_tablet);
//     else maxSlides = Math.ceil(this.config.slide_count / this.config.ipr_desktop);
//     this.indicator_elements.forEach((dot, i) => {
//       dot.style.display = i < maxSlides ? 'block' : 'none';
//       if(maxSlides == 1) {
//         dot.style.display = 'none';
//       }
//     });

//     // Update numeric max
//     if (this.indicator_current) {
//       this.indicator_current.nextElementSibling.textContent = maxSlides;
//     }
//   }
// }

// customElements.define('gridy-slider', GridySlider);

// this code by RSS -- end --  



// QuantityInput for + and - button functionality
// Used in: cart items, upsell items
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input', QuantityInput);

class ClassWatcher {
  constructor(targetNode, classToWatch, classAddedCallback) {
    this.targetNode = targetNode
    this.classToWatch = classToWatch
    this.classAddedCallback = classAddedCallback
    this.observer = null
    this.lastClassState = targetNode.classList.contains(this.classToWatch)

    this.init()
  }

  init() {
    this.observer = new MutationObserver(this.mutationCallback)
    this.observe()
  }

  observe() {
    this.observer.observe(this.targetNode, { attributes: true })
  }

  disconnect() {
    this.observer.disconnect()
  }

  mutationCallback = (mutationsList) => {
    for(let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        let currentClassState = mutation.target.classList.contains(this.classToWatch)
        if(this.lastClassState !== currentClassState) {
          this.lastClassState = currentClassState
          if(currentClassState) {
            this.classAddedCallback()
          }
        }
      }
    }
  }
}

class AnimatedNumber extends HTMLElement {
  constructor() {
    super();
    if ('paintWorklet' in CSS && 'registerProperty' in CSS && 'number' in CSS) {
      // Browser should support all necessary CSS features for an animated counter so exit early
      return;
    }

    this.target = this.querySelector('.animation-target');

    // Set a mutation observer on the parent section element to start the animation when element is scrolled into view
    new ClassWatcher(
      this.closest('.shopify-section'),
      'section-in-view',
      this.onClassAdded.bind(this)
    )
  }

  onClassAdded() {
    const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
    const frames = []

    for (let i = 0; i <= +this.dataset.targetNum; i++) {
      // Content only accepts strings as input, thus the double quotation marks inside the template literal
      frames.push({'content': `"${i}"`})
    }

    const animation = new Animation(
      new KeyframeEffect(
        this.target,
        frames,
        {
          delay: isReduced ? 0 : +this.dataset.animDelay,
          duration: isReduced ? 0 : +this.dataset.animDuration,
          easing: 'cubic-bezier(.33, 0, .1, 1)',
          fill: 'forwards',
          iterations: 1,
          pseudoElement: '::after'
        }
      ),
      document.timeline
    )

    animation.play();
  }
}
customElements.define('animated-number', AnimatedNumber);

// Tab Container - a custom Woolman built container for content in tabs.
// Usage: <tab-container>
class TabContainer extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector('[data-tab-titles]');
    this.slides = this.querySelectorAll('[data-tab-titles] > *');

    this.config = {
      breakpoint_tablet: 768
    }

    this.querySelectorAll('[data-tab-title]').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  scrollToTitle(newPosition) {
    if (isNaN(newPosition)) {
      return;
    }

    if (window.innerWidth >= this.config.breakpoint_tablet) {
      return;
    }

    const slideInNewScrollToPos = this.slides[newPosition];
    const scrollToLeft = this.slides[newPosition].offsetLeft - this.slides[0].offsetLeft;
    const scrollToTop = slideInNewScrollToPos.offsetTop;

    this.track.scrollTo({
      left: scrollToLeft,
      top: scrollToTop,
      behavior: "smooth",
    });
  }

  onButtonClick(event) {
    const id = event.target.closest('button').getAttribute('data-tab-title');
    const titleElems = Array.from(this.querySelectorAll('[data-tab-title]'));
    const contentElems = this.querySelectorAll('[data-tab-content]');
    const collectionLinkElems = this.querySelectorAll('[data-tab-collection-link]');
    const elementIndex = titleElems.findIndex(elem => elem.getAttribute('data-tab-title') === id);

    titleElems.forEach(elem => {
      if (elem.getAttribute('data-tab-title') === id) {
        elem.classList.remove('style--subdued');
        elem.classList.add('is-active');
      } else {
        elem.classList.add('style--subdued');
        elem.classList.remove('is-active');
      }
    })

    contentElems.forEach(elem => {
      if (elem.getAttribute('data-tab-content') === id) {
        elem.classList.remove('hidden');
        if (elem.tagName.toLowerCase() === 'gridy-slider') {
          elem.setTrackWidth();
        }
      } else {
        elem.classList.add('hidden');
      }
    })

    collectionLinkElems.forEach(elem => {
      elem.getAttribute('data-tab-collection-link') === id
        ? elem.classList.remove('hidden')
        : elem.classList.add('hidden')
    })

    this.scrollToTitle(elementIndex)
  }
}
customElements.define('tab-container', TabContainer);

// Shipping notification
customElements.define('shipping-notification', class ShippingNotification extends HTMLElement {
  constructor() {
    super();
    this.elementLevelBarFill = null;
    this.elementMessageParagraph = null;
  }

  connectedCallback() {
    const calcInJS = this.hasAttribute('data-calc-in-js');

    this.elementLevelBarFill = this.querySelector('.level-bar-fill');
    this.elementMessageParagraph = this.querySelector('.free-shipping-message');

    if (!this.elementMessageParagraph) {
      console.warn('shipping-notification: .free-shipping-message not found');
      return;
    }

    if (calcInJS) {
      this.updateShippingNotification();
    }
  }

  disconnectedCallback() {
    // Clean up event listeners (if any in future updates)
    // Example: this.removeEventListener('eventName', this.someHandler);
  }

  get freeShippingThreshold() {
    return parseInt(this.dataset.threshold, 10) || 0;
  }

  get cartTotal() {
    return parseInt(this.dataset.cartTotal, 10) || 0;
  }

  updateShippingNotification() {
    console.log('Free shipping check calculated in JS to match the localized currency:', Shopify.currency.active);

    const exchangeRate = parseFloat(Shopify.currency.rate) || 1;
    const cartTotalInLocalCurrency = Math.round(this.cartTotal / exchangeRate);

    if (!this.elementMessageParagraph) return;

    if (cartTotalInLocalCurrency > this.freeShippingThreshold) {
      this.classList.add('threshold-reached');
      this.elementMessageParagraph.innerHTML = window.cartStrings.shipping_free;
      this.elementLevelBarFill.style.setProperty('--fill-width', '100%');
    } else {
      let missingAmount = this.freeShippingThreshold - cartTotalInLocalCurrency;
      let missingPercentage = (cartTotalInLocalCurrency / this.freeShippingThreshold) * 100;
      let message = window.cartStrings.shipping_not_free.replace('[amount]', Woolman.Utils.formatMoney(missingAmount));

      this.classList.remove('threshold-reached');
      this.elementLevelBarFill.style.setProperty('--fill-width', `${missingPercentage}%`);
      this.elementMessageParagraph.innerHTML = message;
    }
  }
});


// Recommendations
if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', class CartRecommendations extends HTMLElement {
    constructor() {
      super();
      this.loadRecommendations();
      document.addEventListener('ajaxProduct:added', this.loadRecommendations.bind(this))
    }

    async loadRecommendations() {
      console.log("this.dataset.productId",this.dataset.productId);
      if (!this.dataset.productId || this.dataset.productId === '') return;

      try {
        const url = new URL(location.origin + routes.product_recommendations_url + '.json')
        url.searchParams.set('product_id', this.dataset.productId)
        url.searchParams.set('limit', this.dataset.limit || 10)
        
        const res = await fetch(url)
        const { products } = await res.json();

        if (!products || products.length == 0) {
          throw 'No product recommendations found for products in the cart'
        }

        this.productsContainer = this.querySelector('[data-products-ajax]')
        this.productsContainer.innerHTML = '';

        products.forEach((product) => {

          const newItem = this.querySelector('#recommendation-item-template').content.firstElementChild.cloneNode(true);
          const has_variants = product.variants.length > 1 ? true : false;
          const variantSelectContainer = newItem.querySelector('.select');
          const variantSelect = newItem.querySelector('[data-variant-select]');
          const currentAriaLabel = newItem.querySelector('.item-media').getAttribute('aria-label') || '';

          if (product.featured_image) {
            const filename = product.featured_image.split('/').pop();
            const lastDotIndex = filename.lastIndexOf('.');
            const newFilename = `${filename.substring(0, lastDotIndex)}_300x${filename.substring(lastDotIndex)}`;
            const url = product.featured_image.replace(filename, newFilename);
            newItem.querySelector('img').setAttribute('src', url);
            newItem.querySelector('img').setAttribute('alt', product.title);
            newItem.querySelector('.placeholder-svg').remove()
          } else {
            newItem.querySelector('img').remove();
            newItem.querySelector('.item-media').classList.add('media--empty');
          }

          newItem.querySelector('.item-media').setAttribute('href', location.origin + product.url);
          newItem.querySelector('.item-media').setAttribute('aria-label', currentAriaLabel.replace('[product_title]', product.title));
          newItem.setAttribute('title', product.title);
          newItem.querySelector('.item-title a').textContent = product.title;
          newItem.querySelector('.item-title a').setAttribute('href', location.origin + product.url);

          product.variants.forEach((variant) => {
            const option = document.createElement('option');
            option.textContent = variant.title + ' - ' + Woolman.Utils.formatMoney(variant.price);
            option.value = variant.id; // Storing variant ID as the option value
            if (!variant.available) {
              option.disabled = true;
            }
            variantSelect.appendChild(option);
          })

          if (product.price_min !== product.price_max) {
            newItem.querySelector('.price-regular .price-item').textContent = window.themeStrings.from_price_html.replace('[price]', Woolman.Utils.formatMoney(product.price_min));
          } else if (product.compare_at_price > product.price) {
            newItem.querySelector('.price-sale .price-item--regular').textContent = Woolman.Utils.formatMoney(product.compare_at_price);
            newItem.querySelector('.price-sale .price-item--sale').textContent = Woolman.Utils.formatMoney(product.price);
            newItem.querySelector('.price').classList.add('price--on-sale');
          } else {
            newItem.querySelector('.price-regular .price-item').textContent = Woolman.Utils.formatMoney(product.price);
          }

          if (!product.available) {
            // Not available => Disable button
            newItem.querySelector('[data-add-to-cart]').setAttribute('disabled', true);
            newItem.querySelector('[data-add-to-cart]').removeAttribute('data-add-to-cart');
          } else if (has_variants) {
            // Available, multiple variants => Show variant select and hide price
            variantSelectContainer.classList.remove('hide');
            newItem.querySelector('.price').remove();
          } else {
            // Available, single variant => Set button to add to cart
            newItem.querySelector('[data-add-to-cart]').setAttribute('data-add-to-cart', product.variants[0].id);
          }

          this.productsContainer.appendChild(newItem);
        })

        this.addButtonEventListeners();

        requestAnimationFrame(() => {
          this.classList.add('products-loaded');
        });
      } catch(error) {
        this.setAttribute('hidden', true)
        console.warn(error)
      }
    }

    addButtonEventListeners() {
      this.querySelectorAll('[data-add-to-cart]').forEach((button) => {
        button.addEventListener('click', this.onAddToCart.bind(this));
      });
    }

    async onAddToCart(event) {
      event.preventDefault()
      const button = event.currentTarget;
      const parentItem = button.closest('.cart-recommendation-item');
      const variantSelect = parentItem.querySelector('[data-variant-select]');
      const variantId = variantSelect ? variantSelect.value : button.dataset.addToCart;
      const rootUrl = window.routes.root == '/' ? '/' : window.routes.root + '/'; // if user has selected locale convert root url from /en-gb to /en-gb/
      const formData = {
        'items': [{
         'id': variantId,
         'quantity': 1
         }]
      };

      this.resetErrorMessage(parentItem);

      button.setAttribute('disabled', true);
      parentItem.classList.add('loading');

      if (!variantId) {
        console.warn('No variant ID found on the add to cart button');
        return;
      }

      try {
        const response = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });
        const jsonData = await response.json();

        if (!response.ok) {
          const errorMessage = typeof jsonData.description === 'string'
            ? jsonData.description
            : jsonData.message;
          throw new Error(errorMessage);
        }

        const event = new CustomEvent('ajaxProduct:added', { detail: jsonData });
        document.dispatchEvent(event);
      } catch (error) {
        this.handleErrorMessage(error, parentItem);
      }
    }

    handleErrorMessage(errorMessage = false, parentItem) {
      console.log(errorMessage);
      parentItem.classList.remove('loading');
      parentItem.querySelector('[data-add-to-cart]').removeAttribute('disabled');
      const errorMessageWrapper = parentItem.querySelector('.error-message-wrapper');
      if (!errorMessageWrapper) return;
      const errorMessageElement = errorMessageWrapper.querySelector('.error-message');
      errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        errorMessageElement.textContent = errorMessage;
      }
    }

    resetErrorMessage(parentItem) {
      const errorMessageWrapper = parentItem.querySelector('.error-message-wrapper');
      if (!errorMessageWrapper) return;
      const errorMessageElement = errorMessageWrapper.querySelector('.error-message');
      errorMessageWrapper.toggleAttribute('hidden', true);
      errorMessageElement.textContent = '';
    }

  })
}

if (!customElements.get('product-model')) {
  customElements.define('product-model', class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.loadContent();
    }

    loadContent() {
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;
      this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
      this.dataset.loaded = true;
    }
  });
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });


    document.querySelectorAll('.product__xr-button').forEach((btn) => {
      btn.removeAttribute('style');
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});

// custom js for Update cart on Wishlist Product added to cart -- start --
// document.addEventListener('click', async (e) => {
//   const btn = e.target.closest(
//     'button.wishlist-cart, button.wishlist-move-cart'
//   );
//   if (!btn) return;

//   const cart = await fetch('/cart.json').then(r => r.json());

//   document.dispatchEvent(
//     new CustomEvent('ajaxProduct:added', { detail: { cart } })
//   );
// });

document.addEventListener('click', async (e) => {
  const btn = e.target.closest(
    'button.wishlist-cart, button.wishlist-move-cart'
  );
  if (!btn) return;

  try {
    const cart = await fetch('/cart.json').then(r => r.json());

    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', { detail: { cart } })
    );

    document.querySelector('.sewp-close')?.click();
  } catch (err) {
    console.error('Cart update failed', err);
    document.dispatchEvent(new Event('cart:update'));
  }
});

// custom js for Update cart on Wishlist Product added to cart -- end --

// custom js to hide app-injected ".tmenu-watermark" branding -- start --
(function hideTmenuWatermark() {
  const SELECTOR = '.tmenu-watermark span, .tmenu-watermark a';

  const hide = () => {
    document.querySelectorAll(SELECTOR).forEach((el) => {
      // Inline !important so it wins over the app's own styles.
      el.style.setProperty('display', 'none', 'important');
    });
  };

  const init = () => {
    hide();
    // The watermark is injected by a third-party app and can render after page load,
    // so keep watching the DOM and re-hide any newly added nodes.
    new MutationObserver(hide).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// custom js to hide app-injected ".tmenu-watermark" branding -- end --
